import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { withProps } from '../withProps.js';

const IconChevronDown = withProps(props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "eveodd",
  d: "M15.4142 6.41424L8.00003 13.8285L0.585815 6.41424L3.41424 3.58582L8.00003 8.1716L12.5858 3.58582L15.4142 6.41424Z"
})));
IconChevronDown.displayName = 'IconChevronDown';

export { IconChevronDown };
